module.exports = __webpack_public_path__ + "static/img/couponbg.d806fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/couponbg.png
// module id = vTxL
// module chunks = 1